import { render, staticRenderFns } from "./IntegrationsPane.vue?vue&type=template&id=2fcc91a6&scoped=true"
import script from "./IntegrationsPane.vue?vue&type=script&lang=js"
export * from "./IntegrationsPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc91a6",
  null
  
)

export default component.exports